(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
	super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 1) {
		this.header.classList.add('shopify-section-header-sticky','shopify-section-header-always-sticky');
		this.header.style.transform = 'translateY(-100%)';
	};

	if (this.headerIsAlwaysSticky && scrollTop > this.header.offsetHeight + 2) {
		this.header.classList.remove('color-background-2');
		this.header.style.transition = 'background var(--duration-short)';
		this.header.style.transform = 'translateY(0)';
	};

	if (this.headerIsAlwaysSticky && scrollTop < this.header.offsetHeight) {
		this.header.classList.remove('shopify-section-header-sticky');
		this.header.style.transform = 'translateY(0)';
		this.header.style.transition = 'background var(--duration-short)';
		if (this.header.classList.contains('color-background-1')) {
		this.header.classList.add('color-background-2');
		};
	};

	if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (this.preventHide) return;
		requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
		if (!this.preventReveal) {
		requestAnimationFrame(this.reveal.bind(this));
		} else {
			window.clearTimeout(this.isScrolling);

			this.isScrolling = setTimeout(() => {
			this.preventReveal = false;
			}, 66);

			requestAnimationFrame(this.hide.bind(this));
		}
		} else if (scrollTop <= this.headerBounds.top) {
		requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) return;		
		if (document.querySelector(".overflow-hidden-tablet")) return;
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden','color-background-2');
	}

	reset() {
		if (this.headerIsAlwaysSticky) return;
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
		if (this.header.classList.contains('color-background-1')) {
			this.header.classList.add('color-background-2');
		};
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (this.disclosures) {
			this.disclosures.forEach(disclosure => {
				disclosure.close(); 
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			if (this.disclosureLists) {
				this.disclosureLists.forEach(disclosureList => {
					disclosureList.setAttribute('hidden', true); 
				});
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  //class CartNote extends HTMLElement {
  //  constructor() {
  //    super();

  //    this.addEventListener(
  //      'change',
  //      debounce((event) => {
  //        const body = JSON.stringify({ note: event.target.value });
  //        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
  //      }, 300)
  //    );
  //  }
  //}

  //customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();
			this.oneByOneInitialized = false;
			this.oneByOneState = null; // { items, thumbs, currentIndex }
			this.arrowsInitialized = false;
		}

		connectedCallback() {
			if (this.isOneByOneEnabled()) {
				this.initOneByOneGallery();
			}

			this.initArrows();
		}

		isOneByOneEnabled() {
			const isMobileViewport = window.matchMedia('(max-width: 749px)').matches;

			if (isMobileViewport) {
				return this.classList.contains('mobile-gallery-onebyone');
			}

			return this.classList.contains('desktop-gallery-onebyone');
		}

		hide() {
			super.hide();
			window.pauseAllMedia();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		/**
		 * Init des flèches prev/next de la modal
		 */
		initArrows() {
			if (this.arrowsInitialized) return;
			this.arrowsInitialized = true;

			const prevButton = this.querySelector('.product__slider-nav .swiper-button-prev');
			const nextButton = this.querySelector('.product__slider-nav .swiper-button-next');

			if (!prevButton && !nextButton) return;

			if (prevButton) {
				prevButton.addEventListener('click', (event) => {
					console.log('PREV');
					// On ne fait quelque chose que si le mode one-by-one est actif
					if (!this.isOneByOneEnabled() || !this.oneByOneState) return;
					event.preventDefault();

					const { items } = this.oneByOneState;
					if (!items.length) return;

					const prevIndex = (this.oneByOneState.currentIndex - 1 + items.length) % items.length;
					this.setActiveImageByIndex(prevIndex);
				});
			}

			if (nextButton) {
				nextButton.addEventListener('click', (event) => {
					console.log('NEXT');
					if (!this.isOneByOneEnabled() || !this.oneByOneState) return;
					event.preventDefault();

					const { items } = this.oneByOneState;
					if (!items.length) return;

					const nextIndex = (this.oneByOneState.currentIndex + 1) % items.length;
					this.setActiveImageByIndex(nextIndex);
				});
			}
		}

		initOneByOneGallery() {
			if (this.oneByOneInitialized) return;
			this.oneByOneInitialized = true;

			const modalContent = this.querySelector('.product-media-modal__content');
			if (!modalContent) return;

			const items = Array.from(
				modalContent.querySelectorAll('.product-media-modal__item')
			);
			const thumbs = Array.from(
				this.querySelectorAll('.product__media-subitem')
			);

			if (!items.length) return;

			const state = {
				items,
				thumbs,
				currentIndex: 0,
			};

			this.oneByOneState = state;

			// Clic sur une miniature
			state.thumbs.forEach((thumb) => {
				thumb.addEventListener('click', (event) => {
					// Laisser le comportement normal si le one-by-one n'est pas actif
					if (!this.isOneByOneEnabled()) {
						return;
					}

					event.preventDefault();

					const targetId = thumb.dataset.mediaSubId;
					if (!targetId) return;

					this.setActiveImageByModalId(targetId);
				});
			});

			// Clic sur l'image principale → image suivante
			state.items.forEach((item) => {
				item.addEventListener('click', () => {
					if (!this.isOneByOneEnabled()) return;
					if (!this.oneByOneState) return;

					const { items } = this.oneByOneState;
					const nextIndex = (this.oneByOneState.currentIndex + 1) % items.length;
					this.setActiveImageByIndex(nextIndex);
				});
			});
		}

		setActiveImageByIndex(index) {
			if (!this.oneByOneState) return;

			const { items, thumbs } = this.oneByOneState;
			if (!items[index]) return;

			const activeItem = items[index];
			this.oneByOneState.currentIndex = index;

			// toggle sur les images principales
			items.forEach((item) => item.classList.remove('active-image'));
			activeItem.classList.add('active-image');

			// mise à jour de la miniature active
			const activeId = activeItem.dataset.mediaModalId;
			if (activeId && thumbs.length) {
				thumbs.forEach((thumb) => thumb.classList.remove('active'));
				const matchingThumb = thumbs.find(
					(thumb) => thumb.dataset.mediaSubId === activeId
				);
				if (matchingThumb) {
					matchingThumb.classList.add('active');
				}
			}
		}

		setActiveImageByModalId(modalId) {
			if (!this.oneByOneState) return;

			const { items } = this.oneByOneState;
			const index = items.findIndex(
				(item) => item.dataset.mediaModalId === modalId
			);
			if (index === -1) return;

			this.setActiveImageByIndex(index);
		}

		showActiveMedia() {
			const isOneByOne = this.isOneByOneEnabled();

			if (isOneByOne) {
				this.initOneByOneGallery();

				const openerMediaId = this.openedBy?.getAttribute('data-media-id');

				if (openerMediaId && this.oneByOneState) {
					const { items } = this.oneByOneState;
					const itemFromOpener = items.find((item) =>
						item.querySelector(`[data-media-id="${openerMediaId}"]`)
					);

					if (itemFromOpener) {
						const index = items.indexOf(itemFromOpener);
						this.setActiveImageByIndex(index);
						return;
					}
				}

				if (this.oneByOneState && this.oneByOneState.items.length) {
					this.setActiveImageByIndex(0);
				}

				return;
			}

			// Comportement original (liste + scroll)
			const activeMedia = this.querySelector(
				`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`
			);

			if (activeMedia) {
				activeMedia.classList.add('active');
				activeMedia.scrollIntoView();
			}

			if (
				activeMedia &&
				activeMedia.nodeName == 'DEFERRED-MEDIA' &&
				activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')
			) {
				activeMedia.loadContent();
			}
		}
	}

	customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
